<button
  (click)="isOpen = !isOpen"
  class="btn btn-ghost btn-square border"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  ifBadge="{{ notifications().length }}"
  [ifBadgeHidden]="notifications().length === 0"
  aria-label="notifications"
>
  <ng-icon name="heroBell" strokeWidth="2" size="24" class="m-auto" />
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOffsetY]="8"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  (overlayOutsideClick)="isOpen = false"
  (detach)="isOpen = false"
>
  <div
    class="max-w-prose z-10 rounded-sm container text-grey-900 dark:text-grey-100 border border-grey-300 dark:border-grey-600 max-h-[70vh] bg-white/50 dark:bg-grey-700/70 backdrop-blur-md shadow-lvl3 overflow-y-auto flex flex-col gap-1 divide-y-2 divide-grey-300 dark:divide-grey-600"
  >
    @for (notification of notifications(); track notification) {
      <if-notification-card [notification]="notification" (deleteEvent)="onDelete()" />
    } @empty {
      <span class="p-4">Keine aktuellen Benachrichtigungen.</span>
    }
  </div>
</ng-template>
